import { render, staticRenderFns } from "./CountableBadge.vue?vue&type=template&id=8d2a365a&scoped=true&"
import script from "./CountableBadge.vue?vue&type=script&lang=js&"
export * from "./CountableBadge.vue?vue&type=script&lang=js&"
import style0 from "./CountableBadge.vue?vue&type=style&index=0&id=8d2a365a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2a365a",
  null
  
)

export default component.exports